import React from 'react';
import { Icon } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import highlyResponsive from '../assets/highlyReponsive';

const HighlyResponsive = () => (
    <>
        <Icon className="seller-highlight-icon">{highlyResponsive}</Icon>
        <I18n k={'listings.highlights.highly_responsive'} />
    </>
);

export default HighlyResponsive;
